import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute, requireAdmin } from '../route';

const FeatureFlagsPage = lazyRouteComponent(
  () => import('./FeatureFlagsPage'),
  'FeatureFlagsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ff_overrides',
  staticData: {
    app: {
      access: {
        adminOnly: true,
      },
    },
  },
  component: FeatureFlagsPage,
  loader: () => ({
    crumb: msg('Feature Flags', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    // Read-only diagnostics: the Backend column is how you debug a flag that
    // only misbehaves under imitation, so an imitating admin can opt back in
    // through the ImitationBanner's "Admin tools" switch.
    requireAdmin({ context, allowImitationAdminTools: true });
  },
});
